export const HEADER_CHANNELS = ['row', 'column'];
export const HEADER_TYPES = ['header', 'footer'];
//# sourceMappingURL=component.js.map